import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem/SliderListItem';

const TextDriftIntensitySlider = (props) => {
    const { intensity, customMode, index, updateTextElement } = props;

    const onIntensityChange = useCallback((value) => {
        if (value === intensity) return;
        updateTextElement(index, { drift: { intensity: value } });
    }, [index, intensity, updateTextElement]);

    return (
        <SliderListItem
            title='Intensity'
            displayMultiplier={1}
            value={intensity}
            min={0}
            max={100}
            step={1}
            onValueChange={onIntensityChange}
            disabled={customMode}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { drift } = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    return {
        intensity: drift?.intensity ?? 0,
        customMode: Boolean(drift?.customMode)
    };
};

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) =>
        dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextDriftIntensitySlider);
